import { Component } from '@angular/core';

@Component({
    selector: 'app-layout',
    templateUrl: './auth-layout.component.html',
    standalone: false,
})

export class AuthLayoutComponent {}
